export default "__VITE_ASSET__3fd572d0__"